export default {
	type: 'SHOPCART_ROWS',
	name: 'Shopcart rows',
	allowedSections: ['main', 'header', 'footer'],
	disallowedChildren: [],
	category: 'Shopcart',
	props: []
};
